<script setup lang="ts">
import { ref } from 'vue';
import SwitchUserLine from '@/components/dev/SwitchUser/SwitchUserLine.vue';

const users = ref();
const isOpen = ref(false);
const activeUser = window.localStorage.getItem('activeUser') || '0';
const mode = import.meta.env.VITE_DEV_ENV;

if (import.meta.env.DEV) {
  // @ts-ignore
  const module = await import('@/assets/config/dev-users.json');
  users.value = module.default[mode];
}
</script>

<template>
  <v-btn
    class="switch-user_btn"
    @click="isOpen = true"
    size="small"
    variant="outlined"
    icon
    color="primary"
  >
    <v-icon icon="fas fa-user-secret" />
  </v-btn>
  <v-dialog max-width="750px" v-model="isOpen">
    <v-card>
      <v-card-title>Switch User</v-card-title>
      <v-card-subtitle class="pb-4 elevation-1">
        <p>You can add user in './src/assets/config/config.json'</p>
        <p><i>This components is for dev only</i></p>
      </v-card-subtitle>

      <v-card-text class="switch-user_content">
        <v-divider></v-divider>
        <SwitchUserLine
          v-for="(user, index) in users"
          :user="user"
          :active="activeUser === index.toString()"
          :id="index"
          :key="index"
        />
      </v-card-text>

      <v-card-actions class="pt-6 justify-end elevation-4">
        <v-btn variant="tonal" @click="isOpen = false">Fermer</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.switch-user {
  &_content {
    min-height: 200px;
    max-height: 600px;
    overflow-y: auto;
  }
  &_btn {
    z-index: 1000;
    position: fixed;
    bottom: 50px;
    left: 20px;
  }
}
</style>
